var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WysiwygParent",staticStyle:{"background-color":"#fff"},attrs:{"id":_vm.Id}},[_c('textarea',{ref:"textarea"})])
}
var staticRenderFns = []

export { render, staticRenderFns }